export const smoothScroll = (top = 0) => {
  setTimeout(() =>
    window.scrollTo({
      top,
      left: 0,
      behavior: "smooth",
    }), 100);
};